import {BuildingModel} from "@game/coregame/interfaces/BuildingModel";
import {GroupModel} from "./GroupModel";

export class BState {
    constructor(
        public readonly buildings: BuildingModel[],
        public readonly groups: GroupModel[],
        public readonly timestamp: number
    ) {}
    public clone(): BState {
        return new BState(this.buildings, this.groups, this.timestamp);
    }
}
